/*
  YATS wishlist sync (Phase 4 — wishlist → customer metafields)
  --------------------------------------------------------------
  The wishlist is stored client-side in localStorage ('yats-wishlist', an array
  of product handles) and the per-page toggle UIs (collection page, wishlist
  page, account hub) read/write that key directly — unchanged.

  This layer adds server persistence for LOGGED-IN customers:
    • Hydrate down  — on load, merge the customer's saved `yats.wishlist`
                      metafield (seeded into window.YATS_CUSTOMER by the layout)
                      into localStorage, so a saved list follows them across
                      devices, then fires a 'yats:wishlist' event on document so
                      any surface that painted before the merge can re-render.
    • Sync up       — on page exit, POST the current list to the app-proxy
                      endpoint (theme setting "Wishlist sync endpoint", live as
                      /apps/answers/wishlist) which writes the metafield via the
                      Admin API. No-op while the endpoint setting is blank.
                      WIRE CONTRACT (WP-APPS-1, 4 Sep 2026 audit P1): the service
                      reads `items`; the theme used to post `{ wishlist }` only, so
                      every sync wrote an EMPTY list and wiped the saved wishlist.
                      The body now carries BOTH keys during the transition:
                      { items: [...], wishlist: [...] }.

  Loaded with `defer` from the layout after the YATS_CUSTOMER emit — NOT
  synchronously — so inline page scripts that read localStorage at parse time run
  BEFORE the merge; they should listen for 'yats:wishlist' (or re-read after
  DOMContentLoaded) if they must show a list saved on another device on first
  paint. The account hub does both.
*/
(function () {
  var WK = 'yats-wishlist';
  var C = window.YATS_CUSTOMER || { loggedIn: false, wishlist: [], syncEndpoint: '' };

  function readLocal() {
    try { var w = JSON.parse(localStorage.getItem(WK) || '[]'); return Array.isArray(w) ? w : []; } catch (e) { return []; }
  }
  function writeLocal(arr) {
    try { localStorage.setItem(WK, JSON.stringify(arr)); } catch (e) {}
  }
  function union(a, b) {
    var seen = {}, out = [];
    (a || []).concat(b || []).forEach(function (h) {
      if (h && !seen[h]) { seen[h] = 1; out.push(h); }
    });
    return out;
  }
  function announce(merged) {
    try { document.dispatchEvent(new CustomEvent('yats:wishlist', { detail: { merged: merged, list: readLocal() } })); } catch (e) {}
  }

  // --- Hydrate down: server list -> localStorage ---------------------------
  var mergedAny = false;
  if (C.loggedIn && Array.isArray(C.wishlist) && C.wishlist.length) {
    var current = readLocal();
    var merged = union(current, C.wishlist);
    if (merged.length !== current.length) { writeLocal(merged); mergedAny = true; }
  }
  announce(mergedAny);

  // --- Sync up: localStorage -> app proxy (only when configured) -----------
  function pushUp() {
    if (!C.loggedIn || !C.syncEndpoint) return;
    var list = readLocal();
    /* both keys: `items` is what the service reads; `wishlist` kept for the transition */
    var body = JSON.stringify({ items: list, wishlist: list });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(C.syncEndpoint, new Blob([body], { type: 'application/json' }));
      } else {
        fetch(C.syncEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true
        }).catch(function () {});
      }
    } catch (e) {}
  }

  if (C.loggedIn && C.syncEndpoint) {
    window.addEventListener('pagehide', pushUp);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') pushUp();
    });
  }

  // Small public hook for future immediate-write callers.
  window.YATSWish = {
    list: readLocal,
    has: function (h) { return readLocal().indexOf(h) >= 0; },
    push: pushUp
  };
})();
